<template>
  <b-navbar ref="bottomHeader" id="bottom-header" fixed="top" toggleable="md" type="primary">
    <b-container>

      <b-navbar-toggle target="nav-collapse" variant="primary">
        <template #default="{ expanded }">
          <i v-if="expanded" class="fa fa-close text-primary"></i>
          <i v-else class="fa fa-bars text-primary"></i>
        </template>
      </b-navbar-toggle>

      <b-navbar-brand class="mx-auto d-md-none" href="#">
        <img :src="$getConst.images.logo_default" height="40" alt="Hays logo">
      </b-navbar-brand>
      <ProfileDropdown v-if="isMobileView && $route.name !== $getConst.routesNames.selectRole"/>
      <b-collapse id="nav-collapse" is-nav v-if="$route.name !== $getConst.routesNames.selectRole" >
        <template v-if="$store.getters['auth/isAuthenticated']">
          <template v-for="item in this.$getConst.menu">
            <b-navbar-nav :class="'w-100 ' +  justifyMenuClass" v-if="(item.roles && hasRole(item.roles)) || !item.roles">
              <template v-if="!item.children">
                <b-nav-item @click="$router.push({name: item.url})">
                  <AppSvgIcon :icon="item.icon" height="30" :tooltip="$t(item.name)"></AppSvgIcon>
                  <span class="nav-menu ml-1">{{$t(item.name)}}</span>
                </b-nav-item>
              </template>
              <b-nav-item v-else>
                <AppGridDropdown
                  :button-icon="item.icon"
                  :button-text="item.name"
                  :items="isLoading?item.children:''"
                />
              </b-nav-item>
            </b-navbar-nav>
          </template>
        </template>

      </b-collapse>

    </b-container>
  </b-navbar>
</template>

<script>
  import ProfileDropdown from "./ProfileDropdown";
  import AppGridDropdown from "../../common/utils/AppGridDropdown";
  import {getAllScopes} from "../../../api/scopes.api";

  export default {
    name: "BottomHeader",
    components: {AppGridDropdown, ProfileDropdown},
    props: {
      isMobileView: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        isLoading: false,
      }
    },
    created() {
      if (this.isLocalAdmin(this.$store.getters["auth/role"])||this.isSuperAdmin(this.$store.getters["auth/role"])) {
        this.getScopes();
      } else {
        this.isLoading = true;
      }
    },
    computed: {
      justifyMenuClass() {
        let menuArray = Object.entries(this.$getConst.menu).filter(item => {
          return (item[1].roles && this.hasRole(item[1].roles)) || !item[1].roles
        })

        return menuArray.length === 1 ? "justify-content-left" : "justify-content-center";
      }
    },
    methods: {
      getScopes() {
        getAllScopes().then(
          res => {
            let scopes = res.data.filter(scope => scope.is_invoices_enabled === true);
            if (scopes.length === 0) {
              delete this.$getConst.menu.administration.children.vendor;
              delete this.$getConst.menu.administration.children.client;
            }
            this.isLoading = true;
          },
          error => this.handleApiError(error)
        );
      }
    }
  }
</script>

<style scoped>

</style>
